import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InstallMessage, InstallsMessage, MessageData } from 'src/app/model/messages/messages.model';
import { MessagesService } from 'src/app/services/messages/messages.service';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  constructor(private service: MessagesService, private activatedRoute: ActivatedRoute, private router: Router, private builder: FormBuilder) { }

  public identifiant !: string;
  public message!: MessageData;

  public installs!: InstallMessage[];

  install = new FormControl('',[Validators.required]);
  filteredinstalls!: Observable<InstallMessage[]>;

  async ngOnInit(): Promise<void> {

    const params = this.activatedRoute.snapshot.params
    this.identifiant = params.id;

    

    // filter for installs select
    this.filteredinstalls = this.install.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.nom_installation)),
      map(name => (name ? this._filter(name) : this.installs.slice())),
     );

     this.getMessage();
     this.getInstall();
  }


  /**
   * Method called when the user clicks the submit button
   * @param f the NgForm that the user filled
   */
  onSubmit(f: NgForm) {
    var formData: any = new FormData();
    var isactif: number = 0;
    if (f.value.actif) { isactif = 1; }
    var arrayJ: any =
    {
      "id_message": this.identifiant,
      "subject": f.value.subject,
      "content": f.value.message,
      "enabled": isactif
    }

    formData.append('message', JSON.stringify(arrayJ))
    this.service.postMessage(formData).subscribe(
      (data: any) => {
        // console.log(data);
        this.identifiant = data.result.id_message;
        this.router.navigate(['message', this.identifiant]);
      },
      (failure: any) => {
        console.log(failure);
      }
    );
  }

  // Add installation(s) to message
  //If id = '-1' add all installations else id is id_installation
  public addInstallation(id: string) {
    this.service.addInstall(this.identifiant, id)
      .subscribe((data) => {
        console.log(data);
      });
    this.getMessage();
  }

  // Remove installation(s) to message
  //If id = 'all' remove all installations else id is id_message_installation
  public removeInstallation(id: any) {
    if(window.confirm("Sûr ?")){
      this.service.removeInstall(this.identifiant, id)
        .subscribe((data) => {
          console.log(data);
        });
      this.getMessage();
      }
  }

  //Get message datas 

  public getMessage() {
    this.service.getMessage(this.identifiant)
      .subscribe((message) => {
        this.message = message;
      });

  }

  public getInstall(){
    this.service.getInstalls(this.identifiant)
      .subscribe((install) => {
        this.installs = install.installations;
      });
  }

  onSubmitInstall(){
    if(this.install.valid){
    console.log(this.install.value)
    this.addInstallation(this.install.value.id_installation);
    this.getInstall();}
  }

  // Delete this message
  public deleteMessage() {
    if(window.confirm("Voulez-vous vraiment supprimer ce message ?")){
      this.service.deleteMessage(this.identifiant)
        .subscribe((data) => {
          console.log(data);
        });
      this.router.navigate(['/messages-list']);
      }
  }

  // Filter for installation select

  private _filter(name: string): InstallMessage[] {
    const filterValue = name.toLowerCase();
    return this.installs.filter(option => option.nom_installation.toLowerCase().includes(filterValue));
  }

  // Show installation name instead of id
  displayFn(install: InstallMessage): string {
    return install && install.nom_installation ? install.nom_installation : '';
  }



}
